<template>
  <div>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Số dữ liệu mỗi trang',
        'items-per-page-options': [10, 20, 50]
      }"
      :headers="headers"
      v-model="selected"
      :items="auditProductModel"
      :page="page"
      :server-items-length="count"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @update:page="val => updatePagination('page', val)"
      @update:items-per-page="val => updatePagination('itemsPerPage', val)"
      item-key="_id"
      show-select
      disable-sort
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1">
            <BaseSmallInput
              style="max-width: 100%"
              placeholder="Nhập mã model"
              v-model="filter.code_contains"
              @change="
                val => {
                  filter.code_contains = val
                  searchWithOption()
                }
              "
            />
          </td>
          <td colspan="1">
            <BaseSmallInput
              style="max-width: 100%"
              placeholder="Nhập mô tả"
              v-model="filter.description_contains"
              @change="
                val => {
                  filter.description_contains = val
                  searchWithOption()
                }
              "
            />
          </td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
          <td colspan="1"></td>
        </tr>
      </template>
      <template v-slot:[`item.index`]="{ index }">
        {{ (page - 1) * itemsPerPage + index + 1 }}
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <span class="text-ellipsis">{{ item.description }}</span>
            </div>
          </template>
          <span class="white--text text-justify">
            {{ item.description }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.listImei`]="{ item }">
        <div class="imei-list">
          <div v-for="(i, index) in item.listImei" :key="index" class="imei-list__item">
            <span>
              {{ i }}
            </span>
          </div>
        </div>
      </template>
      <template v-slot:[`item.actualQuantity`]="{ item }">
        {{ item.actualQuantity | formatNumber }}
      </template>
      <template v-slot:[`item.requestQuantity`]="{ item }">
        {{ item.requestQuantity | formatNumber }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <TableActions :item="item" />
      </template>
    </v-data-table>
    <DialogEditAuditProduct
      ref="dialog-product"
      @refresh="
        () => {
          initData()
          $emit('refresh')
        }
      "
    />
  </div>
</template>

<script>
import BaseSmallInput from '../../components/basic/BaseSmallInput.vue'
import DialogEditAuditProduct from '@/modules/detail-audit-product/DialogEditAuditProduct.vue'
import { mapActions, mapState } from 'vuex'
import TableActions from '../../modules/audit-product/TableModel/TableActions.vue'
export default {
  components: { TableActions, BaseSmallInput, DialogEditAuditProduct },
  computed: {
    ...mapState({
      selectAuditProduct(state) {
        return state['auditProducts'].item
      },
      auditProductModel(state) {
        return state['auditProducts'].auditProductModel
      },
      count(state) {
        return state['auditProducts'].countAuditProductModel
      },
      headers(state) {
        return state['constant'].AuditProductHeader
      }
    })
  },
  data() {
    return {
      filter: { code_contains: '', description_contains: '' },
      itemsPerPage: 5,
      page: 1,
      selected: [],
      loading: false
    }
  },
  methods: {
    ...mapActions({
      fetchAuditProductModel: 'auditProducts/fetchAuditProductModel',
      countAuditProductModel: 'auditProducts/countAuditProductModel',
      setQuery: 'auditProducts/setQuery'
    }),
    updateMany() {
      this.$refs['dialog-product'].openDialog('many', this.selected)
    },
    async updatePagination(type, val) {
      try {
        this.loading = true
        const page = type === 'page' ? val : 1
        const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
        const params = {
          ...this.filter,
          _sort: 'createdAt:DESC',
          _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
          _limit: itemsPerPage
        }
        this.setQuery(params)
        await this.fetchAuditProductModel({ importCheckId: this.$route.params.id, params })
        this.itemsPerPage = itemsPerPage
        this.page = page
      } catch (e) {
        this.$alert.error('Có lỗi xảy ra!')
      } finally {
        this.loading = false
      }
    },
    async initData() {
      try {
        this.loading = true
        const params = {
          _start: 0,
          _limit: 10,
          _sort: 'createdAt:DESC'
        }
        this.setQuery(params)
        await this.fetchAuditProductModel({
          importCheckId: this.$route.params.id,
          params
        })
        await this.countAuditProductModel({ importCheckId: this.$route.params.id })
      } finally {
        this.loading = false
      }
    },
    async searchWithOption() {
      try {
        this.loading = true
        const params = {
          _start: 0,
          _limit: 10,
          _sort: 'createdAt:DESC',
          ...this.filter
        }
        await this.fetchAuditProductModel({
          importCheckId: this.$route.params.id,
          params
        })
        this.setQuery(params)
        await this.countAuditProductModel({ importCheckId: this.$route.params.id, params: { ...this.filter } })
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra')
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    selectAuditProduct: {
      async handler(val) {
        if (val) {
          this.initData()
        }
      }
    },
    selected: {
      async handler(val) {
        if (val.length) {
          this.$emit('onSelected')
        } else {
          this.$emit('offSelected')
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.imei-list {
  text-align: justify;
  padding: 8px;
  .imei-list__item {
    display: inline-block;
    margin-right: 16px;
  }
}
</style>
